import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import {useForm} from 'react-hook-form';
import '../../../css/reacttab.css';
import Pagination from 'react-bootstrap-4-pagination';
import {Tab,Tabs,TabList,TabPanel} from 'react-tabs';
import '../../../css/apppublic.css';
import Authen from '../../../core/Authen';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {confirmAlert} from 'react-confirm-alert';
import Ultility from '../../../core/Ultility'
import UrlTile from 'ol/source/UrlTile';
import {QuanLyTapTin} from '../../../shared/quanlytaptin/QuanLyTapTin';
import LoaiCayApi from '../../../api/LoaiCayApi';

export const LoaiCay = () => {
    const [listLoaiCay, setListLoaiCay] = useState([]);
    const [filter, setFilter] = useState('');
    const [show,setShow] = useState(false);
    const [isEdit,setIsEdit] = useState(false);
    const [isXem,setIsXem] = useState(false);
    const [loaiCay,setLoaiCay] = useState({});
    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);
    const [isExist,setIsExist] = useState([{Value:false}]);
    const [isValueExist,setIsValueExist] = useState('');

    const {handleSubmit,register, reset,errors} = useForm();

    const [nhanVien, setNhanVien] = useState({});

    useEffect(() => {
        setNhanVien(Authen.getUser());
    }, []);

    const [paginationConfig,setPaginationConfig] = useState({
        totalPages : 1,
        currentPage : 1,
        showMax : 5,
        size : 'sm',
        threeDots : true,
        prevNext : true,
        onClick: function(page){
                if(page!= null)
                {
                    pageIndex = page;
                    loadLoaiCay();
                }
        }
    });

    var pageIndex = 1,pageSize = 20;
 
    const loadLoaiCay = async () =>{
        try{
            const params = {
                keyword: filter,
                pageIndex: pageIndex,
                pageSize: pageSize
            }
            const res = await LoaiCayApi.getPaging(params);
            res.Items.map((x)=>{
                x.Checked = false
            });
            setListLoaiCay(res.Items);
            paginationConfig.totalPages = Math.ceil(res.TotalRow==0?1:res.TotalRow/pageSize);
            paginationConfig.currentPage = pageIndex;
            setPaginationConfig(paginationConfig);
            setIsEdit(false);
            setLoaiCay({});
        }
        catch{
            console.log('loi roi');
        }
        
    }

    useEffect(()=>{
        loadLoaiCay();
        setRoleAdd(Authen.checkQuyen('LOAICAY_CREATE'));
        setRoleEdit(Authen.checkQuyen('LOAICAY_UPDATE'));
        setRoleDel(Authen.checkQuyen('LOAICAY_DELETE'));
    },[])

    const setFilt = (e) => {
        setFilter(e.target.value);
    }

    const Timkiem = () =>{
        loadLoaiCay();
    }

    const handleClose = () => {
        setShow(false);
        setIsXem(false);
        
        }
    const handleShow = () => { 
        setIsXem(false);
        setShow(true);
    }

   
    const rowClick = (Id) =>{
        listLoaiCay.map((x) => {
              if(x.Id === Id){
                  x.Checked = !x.Checked;
                  if(x.Checked)
                  {
                      setIsEdit(true);
                      setLoaiCay(x);
                      reset({
                        Id:x.Id,
                        MaLoai: x.MaLoai,
                        TenLoai: x.TenLoai,
                        GhiChu: x.GhiChu,
                        CreateBy: x.CreateBy,
                        UpdateBy: x.UpdateBy
                    }, [reset])
                  }
                  else
                  {
                      setIsEdit(false);
                      reset({},[reset]);
                      setLoaiCay({});
                  }
              }
              else
              {
                  x.Checked = false;
              }
            }
        )
      }
      
    const handleShowData = () => {
        setIsXem(true);
        setShow(true);
    }

    const onSubmit = async (data) => {
          
        try{
            let exi = isExist;
            exi[0].Value = false;
            setIsExist([...exi]);
            if (!isEdit)
            {
                console.log(isExist);
                listLoaiCay.forEach(x=>{
                    if(x.MaLoai === data.MaLoai)
                    {
                        exi[0].Value = true;
                        setIsExist([...exi]);
                    }
                })
                if(!isExist[0].Value)
                {
                    data.CreateBy = nhanVien.Id;
                    data.UpdateBy =  '';
                    const res = await LoaiCayApi.post(data);
                    setShow(false);
                    setIsXem(false);
                    setIsEdit(false);
                    setLoaiCay({});
                    loadLoaiCay();
                    reset({},[reset]);
                }
            }
            else
            {
                data.CreateBy = '';
                data.UpdateBy =  nhanVien.Id;
                data.MaLoai = loaiCay.MaLoai;
                console.log(loaiCay);
                const res = await LoaiCayApi.put(data);
                setShow(false);
                setIsXem(false);
                setIsEdit(false);
                setLoaiCay({});
                loadLoaiCay();
                reset({},[reset]);
            }
            
        }
        catch(ex){
            console.log(ex.message);
        }
        
    }

     const alertDell = () =>{
        confirmAlert({
            title:'Xóa loại cây',
            message: 'Bạn có chắc muốn xóa loại cây',
            buttons:[
                {
                    label:'Đồng ý',
                    onClick: async () => {
                        const res = await LoaiCayApi.delete(loaiCay.Id);
                        loadLoaiCay();
                        setLoaiCay({});
                        setIsEdit(false);
                    }
                },
                {
                    label:'không',
                    onClick: () => {
                    }
                }
            ]
        });
    }

    useEffect(()=>{
        if(isExist[0].Value === true)
        {
            setIsValueExist('* Mã loại cây đã tồn tại');
        }
        else
        {
            setIsValueExist('');
        }
    }
    ,[isExist[0].Value]);


    return(
        <div className="card shadow mb-1">
            <div className="card-header py-2">
                <div className="row ml-2">
                    <div className="col-md-4">
                        <h6 className="m-0 font-weight-bold text-primary">Loại cây</h6>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group">
                            <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={setFilt}/>
                            <div className="input-group-append">
                                <button className="btn btn-info btn-sm" type="button"  onClick={Timkiem} ><i className='fas fa-search'></i> Tìm kiếm</button>
                            </div>
                        </div>
                    </div>
                    <div className="fluid-container col-md-4 text-right">
                        {roleAdd == true ?<button type="button" className="btn btn-success btn-sm ml-1" onClick={handleShow}><i className='fas fa-plus'></i> Thêm</button>:''}
                        {roleEdit == true ?<button  type="button" className="btn btn-info btn-sm ml-1" disabled={!isEdit} onClick={handleShow}><i className='far fa-edit'></i> Sửa</button>:''}
                        {roleDel == true ?<button  type="button" className="btn btn-danger btn-sm ml-1" disabled={!isEdit} onClick={alertDell} ><i className='fas fa-trash-alt'></i> Xóa</button>:''}
                        <button  type="button" className="btn btn-primary btn-sm ml-1 mr-2" disabled={!isEdit} onClick={handleShowData}><i className='far fa-eye'></i> Xem</button>
                    </div>
                </div>
            </div>

            <div className="card-body">
                <div class="table-responsive">
                   <table className="table table-bordered" width="100%">
                   <thead>
                                <tr>
                                <th className="col-checkbox"></th>
                                <th >Mã loại</th>
                                <th >Tên loại</th>
                                <th >Ghi chú</th>
                                </tr>
                        </thead>
                        <tbody>
                            {
                                listLoaiCay.map((item, key) => {
                                    return (
                                            <tr  key={key} onClick={() => rowClick(item.Id)}>
                                                <td className="col-checkbox">
                                                <input type="Checkbox" checked={item.Checked} onChange={e=>item.Checked = e.target.value}></input>
                                                </td>
                                                <td >{item.MaLoai}</td>
                                                <td>{item.TenLoai}</td>
                                                <td >{item.GhiChu}</td>
                                            </tr>
                                     )
                                })
                            }
                        </tbody>
                    </table>
                    </div>
                    <div className="col-md-12 text-right">
                    <Pagination {...paginationConfig} />
                </div>
            </div>
            <Modal dialogClassName="modalLH" show={show} onHide={handleClose} backdrop="static" keyboard={false} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Loại cây</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    
                        <div className="container-fluid">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group row" hidden={true}>
                                <div className="col-md-3 col-sm-6 col-xl-3 col-form-label">
                                   <label className="nhanTK">ID <code>*</code></label> 
                                </div>
                                <div className="col-md-9 col-sm-6 col-xl-9">
                                    <input className="form-control" name="Id" type="Text" ref={register()}></input>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Mã loại <code>*</code>
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    {isEdit === false? <input className="form-control" name="MaLoai" type="Text" ref={register({required:"Tên mã loại không được trống"})}></input> :
                                                        <input className="form-control" name="MaLoai" type="Text" value={loaiCay.MaLoai}></input>
                                    }
                                    
                                    {isEdit === false? <span className="eRor">{  errors.MaLoai && errors.MaLoai.message}</span>:''}
                                    {isEdit === false?<span className="eRor">{isValueExist}</span>:''}
                                   </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Tên loại
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    <input className="form-control" name="TenLoai" type="Text" ref={register(
                                        /* {required:"Tên alias không được trống"} */
                                        )} ></input>
                                    {/* <span className="eRor">{errors.alias && errors.alias.message}</span> */}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Ghi chú
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    <textarea className="form-control" name="GhiChu" type="Text" ref={register() }></textarea>
                                </div>
                            </div>
                        </form>
                      </div>
                </Modal.Body>
                <Modal.Footer>
                        <a href="#" type="button" className="btn btn-info btn-sm ml-1" onClick={handleSubmit(onSubmit)} hidden={isXem}><i className='fas fa-save'></i> Lưu</a>
                        <a href="#" type="button" className="btn btn-danger btn-sm ml-1" onClick={handleClose} disabled><i className="fas fa-sign-out-alt"></i> Hủy</a>
                </Modal.Footer>
            </Modal>
        </div>

        
    );
};
 